<template>
  <div class="well" style="padding: 0 1em;">
    <table cellpadding="0" cellspacing="0" class="ncut-table-search">
      <tbody>
        <tr>
          <td class="ncut-base-form-text" style="width:7rem;">填表日期：</td>
          <td class="ncut-base-form-ipt" style="width:24rem;" colspan="2">
            <table>
                <tr>
                    <td>
                        <b-form-datepicker v-model="queryInfo.sDate" :max="queryInfo.eDate" locale="zh-TW" style="width: 9.5rem;"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"></b-form-datepicker>
                    </td>
                    <td>
                        <span style="padding: 0.425rem 0 0;">&nbsp;至&nbsp;</span>
                    </td>
                    <td>
                        <b-form-datepicker v-model="queryInfo.eDate" :min="queryInfo.sDate" locale="zh-TW" style="width: 9.5rem;"
                            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"></b-form-datepicker>
                    </td>
                </tr>
            </table>
          </td>
          <td class="ncut-base-form-text" style="width:5rem;">單號：</td>
          <td style="width:7em; padding: 0 0.25rem;">
            <b-form-input v-model="queryInfo.no" placeholder="請輸入單號"></b-form-input>
          </td>
        </tr>
        <tr>
          <td class="ncut-base-form-text" style="width:6rem;">發佈人：</td>
          <td style="width:8rem; ">
            <b-form-input v-model="queryInfo.text" placeholder="請輸入發佈人"></b-form-input>
          </td>
          <td style="padding: 0.25em 1rem; text-align:left;" colspan="3">
            <b-button variant="success" tabindex="3"
                  @click="query()"><b-icon icon="search"/>&nbsp;{{$t('message.Query_cmd')}}</b-button>&nbsp;
                <b-button variant="info" tabindex="3"
                  @click="newItem(0)"><b-icon icon="clipboard-plus"/>&nbsp;{{$t('message.New_txt')}}</b-button>
                <a style="margin: 0 0.5rem; text-decoration: none;" target="_blank" tabindex="4" class="ncut-excel-style"
                    :href="'./WebApi/Meet/GetMeetODS/'.concat(queryInfo.sysId)
                                                        .concat(',').concat(queryInfo.no)
                                                        .concat(',').concat(queryInfo.text)
                                                        .concat(',').concat(getDateFmt(queryInfo.sDate))
                                                        .concat(',').concat(getDateFmt(queryInfo.eDate))
                                                        .concat(',').concat(queryInfo.type)"
                    v-show="total>0">
                    <img src="@/assets/images/ods-file24.png" style="height: 0.8rem;"/> {{$t('message.Excel_txt')}}
                </a>
          </td>
        </tr>
      </tbody>
    </table>
    <b-tabs content-class="mt-3" justified>
        <b-tab title="訊息" :active="dataMode==0" :disabled="dataMode!=0">
          <b-alert show>無相關資料!</b-alert>
        </b-tab>
        <b-tab :active="dataMode==1" :disabled="dataMode!=1">
          <template #title>
            <span v-bind:class="{ 'tab-title': 1==dataMode}">會議記錄-查詢</span> <span v-show="(0 < total) && (1 == dataMode)">［{{total}}］</span>
          </template>
          <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 400px; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
            <table class="ncut-table-menu-striped ncut-table-menu" bgcolor="#FFFFFF">
              <thead class="ncut-thead-menu">
                  <tr>
                  <th style="min-width: 2.5em;">序號</th>
                  <th style="min-width: 5em;">會議單號</th>
                  <th style="min-width: 7em;">發佈人</th>
                  <th style="min-width: 7em;">發佈單位</th>
                  <th style="min-width: 6em;">會議起始日</th>
                  <th style="min-width: 6em;">會議結束日</th>
                  <th style="min-width: 12em;">會議名稱</th>
                  <th style="min-width: 12em;">會議紀錄</th>
                  <th style="min-width: 12em;">會議心得</th>
                  <th style="min-width: 6.25rem;">操作</th>
                  </tr>
              </thead>
              <tbody class="ncut-tbody-menu">
                <tr v-for="(item, index) in filteredDocs" :key="item.documentId" :index="item.documentId" :name="item.documentId"
                  v-bind:style="{'background': (selectedRowIndex==index? headerColor: '')}"
                  @click="selectedRowIndex=index">
                   <td style="text-align: right;">{{(currentPage-1)*pageSize+index+1}}</td>
                  <td style="text-align: left;">{{item.text1}}</td>
                  <td style="text-align: left;">{{item.text2}}</td>
                  <td style="text-align: left; font-size: smaller;">{{item.text3}}</td>
                  <td style="text-align: left;">{{item.startTime | dateFormat}}</td>
                  <td style="text-align: left;">{{item.endTime | dateFormat}}</td>
                  <td style="text-align: left;"><span class="span_text">{{item.text4}}</span></td>
                  <td style="text-align: left;"><span class="span_text">{{item.text5}}</span></td>
                  <td style="text-align: left;"><span class="span_text">{{item.text6}}</span></td>
                <td style="text-align:center; padding: 0.1rem;">
                      <b-button-group>
                      <b-button variant="outline-primary" size="sm" style="font-size:font-size: xx-small; line-height: 1;"
                          @click="showModal(item.id)"><b-icon icon="vector-pen"/><br/>{{$t('message.Edit_txt')}}</b-button>
                      <b-button variant="outline-danger" size="sm" style="font-size:font-size: xx-small; line-height: 1;"
                          @click="remove(item.id)"><b-icon icon="trash"/><br/>{{$t('message.Del_cmd')}}</b-button>
                      </b-button-group>
                  </td>
                </tr>
              </tbody>
          </table>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            v-if="total>pageSize" />
          </div>
        </b-tab>
      </b-tabs>

      <b-modal size="xl" ref="eMeet" hide-footer >
        <template #modal-title>
          會議記錄 ‖ {{modalTitle}}
        </template>
        <eMeet :id=editId @hideModal="hideModal"/>
      </b-modal>

      <b-modal ref="q-modal" hide-footer title="請注意">
        <div class="d-block text-center">
          <h3>是否確認刪除此筆資料?</h3>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="cancalRM">取消刪除</b-button>
        <b-button class="mt-2" variant="outline-info" block @click="confirmRM">刪除確認</b-button>
      </b-modal>
  </div>
</template>

<script  id="modal-template">
import eMeet from '@/components/EditMeet.vue'
import * as tools from '../tool'
export default {
  name: 'formMgt',
  data () {
    return {
      total: 0,
      dataMode: 0,
      currentPage: 1,
      selectedRowIndex: 0,
      editId: 0,
      pageSize: 10,
      queryInfo: {
        sysId: 0,
        no: '',
        text: '',
        sDate: null,
        eDate: null,
        type: 0
      },
      docRecordList: []
    }
  },
  components: {
    eMeet
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    pickerOpt () {
      return tools.pickerOptions2
    },
  	filteredDocs: function () {
      let data = []
      if (this.docRecordList != null) {
        data = this.docRecordList.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      }
      return data
    },
    headerColor () {
      return '#f7e8aa'
    },
    reSetFg2 () {
      return this.$store.getters.getReSetFg2
    },
    modalTitle () {
      return (this.editId > 0 ? '編輯' : '新增')
    }
  },
  filters: {
    dateFormat: function (input) {
      var d = new Date(input)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      return year + '/' + month + '/' + day
    },
    dateFormatV2: function (input) {
      var d = new Date(input)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hh = d.getHours()
      var mm = d.getMinutes()
      return tools.stringFormat('{0}/{1}/{2}', year, month, day)
    }
  },
  methods: {
    newItem () {
      this.editId = 0
      this.$refs.eMeet.show()
    },
    remove (id) {
      this.editId = id
      this.$refs['q-modal'].show()
    },
    cancalRM () {
      this.$refs['q-modal'].hide()
    },
    confirmRM () {
      this.$refs['q-modal'].hide()
      var vm = this
      this.$http.get('./WebApi/Meet/RemoveMeet/'.concat(this.editId))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, 'success', '恭喜您,存檔成功')
            this.editId = 0
            vm.query()
          } else {
            tools.showAlert(vm, 'danger', '對不起,刪除失敗')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '網路連線失敗' + error)
        })
    },
    handleSizeChange (val) {
    },
    handleCurrentChange (val) {
      this.currentPage = val
    },
    getDateFmt (date1) {
      if (!tools.isNull(date1)) {
        return tools.getDateFormat(date1)
      }
    },
    showModal (id) {
      this.editId = id
      this.$refs.eMeet.show()
    },
    hideModal () {
      this.$refs.eMeet.hide()
    },
    pageChanged: function () {
      this.selectedRowIndex = -1
    },
    checkSaveData () {
      const msg = ''

      return msg
    },
    query () {
      var msg = this.checkSaveData()
      if (msg.length == 0) {
        const vm = this
        this.docRecordList = null
        this.total = 0

        this.$http.put('./WebApi/Meet/GetMeetList', this.queryInfo)
          .then((response) => {
            if (response.data != null) {
              vm.docRecordList = response.data
              vm.total = vm.docRecordList.length
            }
            vm.dataMode = (vm.total > 0 ? 1 : 0)
            this.handleCurrentChange(1)
          })
          .catch(function (error) {
            tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
          })
      } else {
        tools.showAlert(this, 'danger', '對不起,請輸入' + msg)
      }
    }
  },
  created () {
    // console.log('======created MinuTakerView =====');
    var today = new Date()
    var yy = today.getFullYear()
    var mm = today.getMonth()
    var dd = today.getDate()
    this.queryInfo.sysId = this.sysId
    this.queryInfo.sDate = new Date(yy, mm, dd - 7)
    this.queryInfo.eDate = new Date(yy, mm, dd)
  },
  beforeDestroy () {
    if (this.modalFlag == 1) {
      this.$modal.hide('unsaved')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn1 {
  color: #e2e1e4;
  background-color: #c1651a;
  border-color: #a7a8bd;
}
.btn2 {
  color: #e2e1e4;
  background-color: #1a3b32;
  border-color: #a7a8bd;
}
.span_text {
    display: block;
    width: 20rem;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}
</style>
